import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import PermitMap from 'ui-permit/src/shared/components/PermitMap';

const propTypes = {
  permit: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }),
  selectedDivision: PropTypes.object
};
const defaultProps = {};

export class DivisionsMapContainer extends React.Component {
  static displayName = 'DivisionsMapContainer';

  constructor(props) {
    super(props);

    this.state = {
      lines: null,
      points: null,
      polygons: null
    };
  }

  componentDidMount() {
    fetch(`/shared/inyonwhitney/data/233262/features.json`, {
      credentials: 'include'
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({
          lines: json.lines,
          points: json.points,
          polygons: json.polygons
        });
      })
      .catch(() => {});
  }

  render() {
    let selectedFeatureId = null;

    if (this.props.selectedDivision) {
      selectedFeatureId = this.props.selectedDivision.id;
    }

    return (
      <PermitMap
        center={this.props.permit && this.props.permit.latitude && this.props.permit.longitude ? [
          this.props.permit.longitude,
          this.props.permit.latitude
        ] : [
          0,
          0
        ]}
        geoJsonLines={this.state.lines}
        geoJsonPoints={this.state.points}
        geoJsonPolygons={this.state.polygons}
        mapContainer="map"
        selectedFeatureId={selectedFeatureId} />
    );
  }
}

DivisionsMapContainer.propTypes = propTypes;
DivisionsMapContainer.defaultProps = defaultProps;

export default connect((state) => {
  return {
    permit: state.inyonwhitney.permit.result,
    selectedDivision: state.inyonwhitney.selectedDivision
  };
})(DivisionsMapContainer);
